import { useState } from 'react';

type NumberProps = {
    number: number;
    duration?: number;
    delay?: number;
};

const defaultDuration = 800;
const defaultDelay = 0;

const NumberEffect = (props: NumberProps) => {
    const { number, duration, delay } = props;
    const [currentNumber, setNumber]: any = useState( 0 );
    const changeSpeed: number = (duration || defaultDuration ) / number;
    const transitionDelay: number = currentNumber === 0 ? (delay || defaultDelay) : defaultDelay;

    const timerId = setTimeout(() => {
        clearInterval(timerId);
        if (currentNumber === number) return;
        setNumber(currentNumber + 1);
    }, changeSpeed + transitionDelay);
    return (
        <>
            {currentNumber}
        </>
    );
}

export default NumberEffect;